import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Faqartist from "../Pages/Faqartist/Faq";
import Faqcenterartist from "../Pages/Faqartist/Faqcenter";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Artistfaqtheme() {
  return (
    <>
      <Header />
      <Faqartist />
      <Faqcenterartist />
      {/* <Latestupdate /> */}
      <Footer />
    </>
  );
}
